<template>
  <div class="play-video" v-if="seen" @click="close_box" @keyup="esc_close">
    <div class="video-loader" v-if="!play">
      <span>
        <svg
          width="120px"
          height="120px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          class="lds-dual-ring"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="round"
            r="20"
            stroke-width="4"
            stroke="#039aed"
            stroke-dasharray="31.41592653589793 31.41592653589793"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </span>
      <br />
      <span>Loading file....</span>
    </div>
    <div class="player" v-if="play">
      <vue-plyr>
        <audio controls>
          <source :src="src" :type="format" />
        </audio>
      </vue-plyr>
    </div>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import config from "@/services/config";
import cookies from "@/services/cookies";
export default {
  data() {
    return {
      seen: false,
      src: "",
      format: "",
      play: false,
    };
  },
  methods: {
    logincall() {
      this.$parent.logincall();
    },
    load(id) {
      this.seen = true;
      let that = this;
      this.src = "";
      this.play = false;

      let data = {
        token: cookies.getCookie("token"),
        id: id,
      };

      const src = `${process.env.VUE_APP_FILE_WATCHER_SERVER}/files/${id}`;
      that.format = data.format;
      setTimeout(function () {
        that.play = true;
      }, 2000);

      // this.$socket.emit('load-video', data, function(data) {
      //     if(data.data === true) {
      //         const src = process.env.VUE_APP_FILE_WATCHER_SERVER + "/files/"+ id;
      //         // that.src = that.src = process.env.VUE_APP_HTTP+'://'+config.origin+':'+process.env.VUE_APP_PORT+'/video/'+id+'/'+cookies.getCookie('token')
      //         that.format = data.format
      //         setTimeout(function() {
      //             that.play = true
      //         }, 2000)
      //     }

      //     if(data.data === false) {
      //         that.seen = false
      //         that.logincall()
      //     }
      // })
    },
    esc_close(e) {
      if (e.keyCode == 27) {
      }
    },
    close_box(evt) {
      if (evt.target.className === "play-video") {
        this.seen = false;
        this.src = "";
      }
    },
  },
};
</script>